import { BrowserModule } from "@angular/platform-browser";
import { importProvidersFrom, NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// layouts
import { AdminComponent } from "./layouts/admin/admin.component";
import { AuthComponent } from "./layouts/auth/auth.component";

// admin views
import { DashboardComponent } from "./views/admin/dashboard/dashboard.component";

// auth views
import { LoginComponent } from "./views/auth/login/login.component";
import { RegisterComponent } from "./views/auth/register/register.component";

// no layouts views
import { IndexComponent } from "./views/index/index.component";
import { LandingComponent } from "./views/landing/landing.component";
import { ProfileComponent } from "./views/profile/profile.component";

// components for views and layouts

import { AdminNavbarComponent } from "./components/navbars/admin-navbar/admin-navbar.component";
import { AuthNavbarComponent } from "./components/navbars/auth-navbar/auth-navbar.component";
import { CardBarChartComponent } from "./components/cards/card-bar-chart/card-bar-chart.component";
import { CardLineChartComponent } from "./components/cards/card-line-chart/card-line-chart.component";
import { CardPageVisitsComponent } from "./components/cards/card-page-visits/card-page-visits.component";
import { CardProfileComponent } from "./components/cards/card-profile/card-profile.component";
import { CardSettingsComponent } from "./components/cards/card-settings/card-settings.component";
import { CardSocialTrafficComponent } from "./components/cards/card-social-traffic/card-social-traffic.component";
import { CardStatsComponent } from "./components/cards/card-stats/card-stats.component";
import { CardTableComponent } from "./components/cards/card-table/card-table.component";
import { FooterAdminComponent } from "./components/footers/footer-admin/footer-admin.component";
import { FooterComponent } from "./components/footers/footer/footer.component";
import { FooterSmallComponent } from "./components/footers/footer-small/footer-small.component";
import { HeaderStatsComponent } from "./components/headers/header-stats/header-stats.component";
import { IndexNavbarComponent } from "./components/navbars/index-navbar/index-navbar.component";
import { MapExampleComponent } from "./components/maps/map-example/map-example.component";
import { IndexDropdownComponent } from "./components/dropdowns/index-dropdown/index-dropdown.component";
import { TableDropdownComponent } from "./components/dropdowns/table-dropdown/table-dropdown.component";
import { PagesDropdownComponent } from "./components/dropdowns/pages-dropdown/pages-dropdown.component";
import { NotificationDropdownComponent } from "./components/dropdowns/notification-dropdown/notification-dropdown.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { UserDropdownComponent } from "./components/dropdowns/user-dropdown/user-dropdown.component";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { BlogComponent } from "./views/blog/blog.component";
import { BlogDetailComponent } from "./views/blog/blog-detail/blog-detail.component";
import { DoctorDetailComponent } from "./views/doctor/doctor-detail/doctor-detail.component";
import { DoctorsListComponent } from "./views/doctor/doctors-list/doctors-list.component";
import { VisitDetailComponent } from "./views/visit/visit-detail/visit-detail.component";
import { UserLayoutModule } from "./views/admin/user-layout.module";
import { VisitLinkComponent } from "./views/visit/visit-link/visit-link.component";
import { AbstractSecurityStorage, AuthModule, LogLevel } from "angular-auth-oidc-client";
import { UserAccountDropdownComponent } from "./components/dropdowns/user-account-dropdown/user-account-dropdown.component";
import { SharedModule } from "./shared/shared.module";
import { LanguagesDropdownComponent } from "./components/dropdowns/languages-dropdown/languages-dropdown.component";
import { CookieService } from "ngx-cookie-service";
import { SearchComponent } from "./components/search/search.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastModule } from 'primeng/toast';
import { MessageService } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { TermsComponent } from "./views/terms/terms.component";
import { PrivacyComponent } from "./views/privacy/privacy.component";
import { AboutUsComponent } from "./views/about-us/about-us.component";
// import { AuthInterceptor } from "./shared/intercepter/auth.intercepter";
import { RatingModule } from 'primeng/rating';
import { PaginatorModule } from "primeng/paginator";

@NgModule({
  declarations: [
    AppComponent,
    CardBarChartComponent,
    CardLineChartComponent,
    IndexDropdownComponent,
    PagesDropdownComponent,
    TableDropdownComponent,
    NotificationDropdownComponent,
    UserDropdownComponent,
    LanguagesDropdownComponent,
    UserAccountDropdownComponent,
    SidebarComponent,
    FooterComponent,
    FooterSmallComponent,
    FooterAdminComponent,
    CardPageVisitsComponent,
    CardProfileComponent,
    CardSettingsComponent,
    CardSocialTrafficComponent,
    CardStatsComponent,
    CardTableComponent,
    HeaderStatsComponent,
    MapExampleComponent,
    AuthNavbarComponent,
    AdminNavbarComponent,
    IndexNavbarComponent,
    AdminComponent,
    AuthComponent,
    LoginComponent,
    RegisterComponent,
    IndexComponent,
    LandingComponent,
    ProfileComponent,
    BlogComponent,
    BlogDetailComponent,
    DoctorDetailComponent,
    DoctorsListComponent,
    VisitDetailComponent,
    VisitLinkComponent,
    TermsComponent,
    PrivacyComponent,
    AboutUsComponent
  ],
  imports: [
    UserLayoutModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ToastModule,
    FormsModule,
    RatingModule,
    PaginatorModule,
    TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),
    AuthModule.forRoot({
      config: {
        authority: 'https://mac.medis.land',
        redirectUrl: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        clientId: 'd34c2276-9c84-4f89-893d-5d9ea3c9aec2',
        scope: 'openid profile apiService_281ce66d-c5e0-443c-9c6b-4ae8050a69cf offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
        triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
        // allowUnsafeReuseRefreshToken: true, // this is required if the refresh token is not rotated
        // autoUserInfo: false, // if the user endpoint is not supported
        logLevel: LogLevel.Debug,
        // disablePkce: false,
        silentRenewUrl: `${window.location.origin}/assets/silent-renew.html`,
        tokenRefreshInSeconds: 60, // Refresh tokens 1 minute before expiry
        renewTimeBeforeTokenExpiresInSeconds: 30, // Renew 30 seconds before token expiry
        refreshTokenRetryInSeconds:30,
        // customParamsAuthRequest: {},
      },
    }),
    SharedModule,
    SearchComponent
],
exports: [
  VisitLinkComponent,
  VisitDetailComponent
],
  providers: [
    CookieService,
    MessageService,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AuthInterceptor,
    //   multi: true,
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
